import { Button, Spinner } from '@monksflow/monks-ui';
import { RefreshCwIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface SuggestedAudiencesNoticeProps {
  isBuilding: boolean;
  hasFailures: boolean;
  isRetrying: boolean;
  onRetry: () => void;
}

/**
 * Says what is happening to the audiences below it, at the level the work happens: a run
 * covers the whole set, so one line speaks for all of them rather than each card explaining
 * itself. Says nothing when there is nothing to say.
 */
export const SuggestedAudiencesNotice = ({
  isBuilding,
  hasFailures,
  isRetrying,
  onRetry,
}: SuggestedAudiencesNoticeProps) => {
  const { t } = useTranslation('analysis');

  if (isBuilding) {
    return (
      <div
        className="flex items-center gap-2 text-sm text-muted-foreground"
        data-testid="suggested-audiences-building"
      >
        <Spinner size="sm" />
        {t('analysisResult.suggestedAudiences.buildingAudiences')}
      </div>
    );
  }

  if (!hasFailures) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center gap-3 text-sm text-muted-foreground">
      {t('analysisResult.suggestedAudiences.someAudiencesCouldNot')}
      <Button variant="outline" size="mini" onClick={onRetry} disabled={isRetrying}>
        {isRetrying
          ? t('analysisResult.suggestedAudiences.retrying')
          : t('analysisResult.suggestedAudiences.tryAgain')}
        {isRetrying ? <Spinner size="sm" /> : <RefreshCwIcon size={15} />}
      </Button>
    </div>
  );
};
